const isValidJson = (str) => {
  try {
    JSON.parse(str);
  } catch (err) {
    return false;
  }
  return true;
};

export const getStoredState = (storageKey) => {
  const storedItem = sessionStorage.getItem(storageKey);

  if (!storedItem) {
    return null;
  }

  if (!isValidJson(storedItem)) {
    console.error(`Stored item ${storageKey} is not valid JSON`);

    return null;
  }

  return JSON.parse(storedItem);
};

export const emptyStoredState = (storageKey) => {
  const storedItem = sessionStorage.getItem(storageKey);

  if (!storedItem) {
    return null;
  }

  if (!isValidJson(storedItem)) {
    console.error(`Stored item ${storageKey} is not valid JSON`);

    return null;
  }

  sessionStorage.removeItem(storageKey);

  return null;
};

export const setStoredState = (storageKey, state) => {
  sessionStorage.setItem(storageKey, JSON.stringify(state));
};
